module["exports"] = [
  "#{prefix} #{first_name} #{last_name}",
  "#{first_name} #{last_name} #{suffix}",
  "#{first_name} #{last_name}",
  "#{first_name} #{last_name}",
  "#{first_name} #{tussenvoegsel} #{last_name}",
  "#{first_name} #{tussenvoegsel} #{last_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nl/name/name.js
// module id = 1095
// module chunks = 0